import React from 'react';
import PropTypes from 'prop-types';
import Video from '../Video';
import NasDailyLightIcon from '../Icons/NasDailyLightIcon';
import ProjectNightfallCreatorIcon from '../Icons/ProjectNightfallCreatorIcon';
import AlyneCreatorIcon from '../Icons/AlyneCreatorIcon';
import MingCreatorIcon from '../Icons/MingCreatorIcon';
import MarkianCreatorIcon from '../Icons/MarkianCreatorIcon';
import Image, { ImageDataType } from '../Image';
import PageSectionTitle, { PageSectionTextType } from '../PageSectionTitle';
import Text, { TextType } from '../Text';
import { Link } from 'react-router-dom';

import './CreatorCard.scss';
import MetakovanCreatorIcon from '../Icons/MetakovanCreatorIcon';

const className = 'c-CreatorCard';

const defaultVideoProps = {
  loop: true,
  autoPlay: true,
  playsInline: true,
  muted: true,
  poster: null,
  checkIsInView: false,
  order: 0,
};

const CreatorCard = ({
  videoProps,
  iconName,
  name,
  courseNameLabel,
  statCount,
  statLabel,
  statUnit,
  cover,
  type,
  courseLink
}) => {
  const renderIcon = () => {
    switch (iconName) {
      case 'nasDailyLightIcon':
        return <NasDailyLightIcon />;
      case 'projectNightfallCreatorIcon':
        return <ProjectNightfallCreatorIcon />;
      case 'alyneCreatorIcon':
        return <AlyneCreatorIcon />;
      case 'mingCreatorIcon':
        return <MingCreatorIcon />;
      case 'markianCreatorIcon':
        return <MarkianCreatorIcon />;
      case 'metakovanCreatorIcon':
        return <MetakovanCreatorIcon />;
      default:
        return null;
    }
  };

  const renderCover = () => (
    <div className={`${className}__media-wrapper`}>
      {type === 'image' && <Image {...cover} />}

      {type === 'video' && <Video srcMap={videoProps} {...defaultVideoProps} />}
    </div>
  );

  return (
    <div className={`${className}`}>
      <Link to={courseLink} title="Creator Page">
        <div className={`${className}__content`}>
          {/* Name */}
          <div className={`${className}__top-row`}>
            <PageSectionTitle title={courseNameLabel} />
          </div>

          {/* Info */}
          <div className={`${className}__bottom-row`}>
            <div
              className={`${className}__content-column ${className}__info-column`}
            >
              {/* Trainer Name */}
              <Text text={name} />
            </div>

            <div className={`${className}__content-column`}>
              <div className={`${className}__icon`}>
                {/* Icon */}
                {renderIcon()}
              </div>
              {/* Stats */}
              <div className={`${className}__stats`}>
                <label>{statLabel}</label>
                <div className={`${className}__stats__wrapper`}>
                  <span className={`${className}__stats__number`}>
                    {statCount}
                  </span>
                  <span className={`${className}__stats__unit`}>
                    {statUnit}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {renderCover()}
      </Link>
    </div>
  );
};

export const CreatorCardDataType = PropTypes.shape({
  videoProps: PropTypes.array,
  name: TextType,
  courseNameLabel: PageSectionTextType,
  statCount: PropTypes.string.isRequired,
  statLabel: PropTypes.string.isRequired,
  statUnit: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  cover: PropTypes.shape(ImageDataType),
  type: PropTypes.oneOf(['video', 'image']),
  order: PropTypes.number,
});

CreatorCard.propTypes = {
  videoProps: PropTypes.array,
  name: TextType,
  courseNameLabel: PageSectionTextType,
  followersCount: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  cover: PropTypes.shape(ImageDataType),
  type: PropTypes.oneOf(['video', 'image']),
  order: PropTypes.number,
};

export default CreatorCard;
